/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featurepersonalizedtitle2Inputs */

const zh_about_featurepersonalizedtitle2 = /** @type {(inputs: About_Featurepersonalizedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个性化学习路径`)
};

const en_about_featurepersonalizedtitle2 = /** @type {(inputs: About_Featurepersonalizedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalized Learning Paths`)
};

const es_about_featurepersonalizedtitle2 = /** @type {(inputs: About_Featurepersonalizedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutas de aprendizaje personalizadas`)
};

/**
* | output |
* | --- |
* | "Personalized Learning Paths" |
*
* @param {About_Featurepersonalizedtitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featurepersonalizedtitle2 = /** @type {((inputs?: About_Featurepersonalizedtitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featurepersonalizedtitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featurepersonalizedtitle2(inputs)
	if (locale === "en") return en_about_featurepersonalizedtitle2(inputs)
	return es_about_featurepersonalizedtitle2(inputs)
});
export { about_featurepersonalizedtitle2 as "about_featurePersonalizedTitle" }